import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './Button';

interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <div className="flex items-center space-x-2 text-red-400 bg-red-400/10 p-3 rounded-lg">
    <AlertCircle className="w-5 h-5" />
    <span>{message}</span>
  </div>
);

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary
}) => {
  return (
    <div className="min-h-[200px] flex items-center justify-center">
      <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6 max-w-md w-full text-center">
        <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-purple-200 mb-2">
          Ops! Algo deu errado
        </h2>
        <p className="text-purple-200/70 mb-4 text-sm">
          {error.message || 'Ocorreu um erro inesperado'}
        </p>
        <Button
          onClick={resetErrorBoundary}
          icon={<RefreshCw className="w-4 h-4" />}
        >
          Tentar Novamente
        </Button>
      </div>
    </div>
  );
};